/**
 * JWT payload 디코더 — 의존성 zero 모듈.
 *
 * services/jwt/index.js 는 redux store('index')·myNet·antd·i18n 을 top-level import 하므로,
 * 순수 디코더만 필요한 소비처(services/passkey/deviceUnlock 등)가 그 체인을 끌어오지 않도록
 * 분리한다 (frontend/CLAUDE.md extensionBridge 의존성-zero 헬퍼 원칙). 새 import 추가 금지.
 */
// named export 는 jwt/index.js re-export 호환용 — default 는 import/prefer-default-export 충족용 병행
export const decodeJwtPayload = (token) => {
  // 비문자열/형식 불일치(JWT 3분절 아님)는 예외 없이 조용히 null — getDeviceScopeId 가
  // MPW 마운트마다 호출하므로 손상 토큰의 TypeError catch 가 콘솔/Sentry 노이즈가 되는 것 방지
  // (gemini 리뷰 #1309)
  if (typeof token !== 'string') return null
  const parts = token.split('.')
  if (parts.length !== 3) return null

  try {
    const payloadBase64 = parts[1]
    const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/')
    const padding = '='.repeat((4 - (base64.length % 4)) % 4)
    const base64WithPadding = base64 + padding

    const decodedStr = atob(base64WithPadding)
    return JSON.parse(decodedStr)
  } catch (error) {
    console.error('Error decoding JWT payload:', error)
    return null
  }
}

export default decodeJwtPayload
